/**
 * Task #1829 — Socket.IO listener globale per eventi MCP catalog.
 *
 * Su `mcp:server_added` / `mcp:server_removed` / `mcp:server_revoked`
 * invalida le query React Query rilevanti senza reload pagina.
 */

import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useSocketOptional } from '@/contexts/SocketContext';
import { useAuth } from '@/contexts/AuthContext';

const INVALIDATE_KEYS = [
  ['mcp-servers'],
  ['workflow-available-nodes'],
  ['agent-bindings'],
  ['mcp-catalog-presets'],
  ['mcp-all-tools-bindings'],
];

export function useMcpRealtimeInvalidation(): void {
  const queryClient = useQueryClient();
  const socketCtx = useSocketOptional();
  const { user } = useAuth();
  const tenantId = user?.tenant_id;

  useEffect(() => {
    if (!socketCtx || !tenantId) return;
    const room = `tenant:${tenantId}`;
    socketCtx.joinRoom(room);

    const handler = (): void => {
      for (const key of INVALIDATE_KEYS) {
        queryClient.invalidateQueries({ queryKey: key });
      }
    };

    const events = ['mcp:server_added', 'mcp:server_removed', 'mcp:server_revoked'] as const;
    for (const e of events) socketCtx.on(e, handler);
    return () => {
      for (const e of events) socketCtx.off(e, handler);
    };
  }, [socketCtx, tenantId, queryClient]);
}
